module.exports = __webpack_public_path__ + "static/img/panorama.266681d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/panorama.png
// module id = GTaT
// module chunks = 2